import { ITranslations } from 'types/common';
import { BrandsTableTransFields } from './types';
import en from 'translations/en/brandsTable.json';
import pl from 'translations/pl/brandsTable.json';
import sl from 'translations/sl/brandsTable.json';

export const brandsTableTranslations: ITranslations<BrandsTableTransFields> = {
  name: 'brandsTable',
  en,
  pl,
  sl,
};
